import { useMutation } from '@tanstack/react-query';

import { ENDPOINTS, KeyImageLabel } from '@/api';
import { fetcher } from '@/api/fetcher';

export const useKeyImageLabelCreatorMutation = () => {
  const mutation = useMutation({
    mutationFn: async (keyImageLabel: Partial<KeyImageLabel>) => {
      const { data } = await fetcher.FCT.post<KeyImageLabel>(
        ENDPOINTS.FCT.KEY_IMAGE.BASE,
        keyImageLabel,
      );

      return data;
    },
  });

  return mutation;
};
